export default __webpack_public_path__ + "static/media/diamond_normal.afdd5103.png";